<template>
    <div class="banner-header" v-if="show">
      <div class="banner-left">
        <img :src="img"/>
        <div :class="closeCss" @click="close()">
          <span>×</span>
        </div>
        <div class="title">
          <div class="title-head">打开一起买买买APP</div>
          <div class="title-footer">每人送积分可免单</div>
        </div>
      </div>
      <div class="banner-right" @click="public.downloadApp(type)">
        <button>
          立即下载
        </button>
      </div>
    </div>
</template>
<script>
  export default{
    name:'header',
    props:['type'],
    data(){
      return {
        param:'',
        show:false,
        closeCss:'',
        img:require("../../../static/img/H5_logo_03.png")
      }
    },
    created(){
      if(this.type!=this.headType.share && this.type!=this.headType.wxDetail){
        let x = window.localStorage.getItem(this.getNowDay());
        if(typeof x!='undefined' && x!=null){
          this.show=false;
        }
      }
      if(this.isAndroid){
        this.closeCss = "closeAndroid";
      }else if(this.isIos){
        this.closeCss = "closeIos";
      }
    },
    mounted(){

    },
    methods:{
      getNowDay(){
        let date = new Date();
        let month = date.getMonth()+1;
        let day = date.getDate();
        let monthStr = "";
        let dayStr = "";
        if(month<10){
          monthStr = "0"+month;
        }else{
          monthStr = month+"";
        }
        if(day<10){
          dayStr = "0"+day;
        }else{
          dayStr = day+"";
        }
        return monthStr+"-"+dayStr;
      },
      close(){
        this.show = false;
        if(this.type!=this.headType.share){
          window.localStorage.setItem(this.getNowDay(),1);
          this.watcher.$emit('closeHeader',this.type)
        }else{
          this.watcher.$emit('closeHeader',this.type)
        }
      }
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// TotalHeader.vue?1bedfe56